import Base64 from 'crypto-js/enc-base64';
import sha256 from 'crypto-js/sha256';
import hmacSHA256 from 'crypto-js/hmac-sha256';
import CryptoJS from 'crypto-js';
import Axios from 'axios';
import Env from './env';
import store from '@/vuex/index';
const baseLogPath = '/log/log/v2/logH5';

export const BaseUrls = {
  develop: `${Env.baseURL}${baseLogPath}`, // 开发版本/开发环境
  trial: `${Env.baseURL}${baseLogPath}`, // 体验版本/测试环境
  'pre-release': `${Env.baseURL}${baseLogPath}`, // 体验版本/预生产环境
  release: `${Env.baseURL}${baseLogPath}` // 正式版本/生产环境
};
export const LogKeys = {
  develop: '2245691293b243dbbd5a743992cee613', // 开发版本/开发环境
  trial: '2245691293b243dbbd5a743992cee613', // 体验版本/测试环境
  'pre-release': '2245691293b243dbbd5a743992cee613', // 体验版本/预生产环境
  release: '2245691293b243dbbd5a743992cee613' // 正式版本/生产环境
};
const getUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
function getAnonymityId() {
  const WEB_ANOYMITYID_DEVICE_ID = 'WEB_ANOYMITYID_DEVICE_ID';
  let anonymityId = window.localStorage.getItem(WEB_ANOYMITYID_DEVICE_ID);
  if (!anonymityId) {
    anonymityId = getUuid();
    window.localStorage.setItem(WEB_ANOYMITYID_DEVICE_ID, anonymityId);
  }
  return anonymityId;
}
function getHeader(data: any) {
  const timestamp = Math.trunc(new Date().getTime() / 1e3);
  const nonce = getXIngeekNonce(timestamp);
  const signature = getXIngeekSignature(timestamp, nonce, Env.version, data);
  let deviceId = '';
  if (store.state.env.deviceId && store.state.env.deviceId !== 'ingeek-web') {
    deviceId = store.state.env.deviceId;
  } else {
    deviceId = getAnonymityId();
  }

  return {
    'X-Nokey-AppId': 'h53f9a17e06e224a9189b71283f0e2012b',
    'X-Nokey-AccessToken': '',
    'X-Nokey-UserId': '',
    'X-Nokey-DeviceId': deviceId,
    'X-Nokey-OSVersion': `${store.state.env.model}_${Env.version}`,
    'X-Nokey-Nonce': nonce,
    'X-Nokey-Timestamp': timestamp.toString(),
    'X-Nokey-Signature': signature,
    'X-Nokey-AppVersion': Env.version || '1.0.0',
    Accept: 'application/json'
  };
}

function sortObject(bodyObj: Record<string, any>) {
  const orderBody: { [key in keyof typeof bodyObj]: any } = {};
  Object.keys(bodyObj)
    .sort()
    .forEach(function (key) {
      orderBody[key] = bodyObj[key];
    });
  return orderBody;
}
function getXIngeekNonce(timestamp: number) {
  const radom = Math.random();
  const nonce = Base64.stringify(sha256((timestamp + radom).toString()));
  return nonce;
}

// 获取日志的signature
function getXIngeekSignature(
  timestamp: number,
  nonce: string,
  version: string,
  body: Record<string, any> = {}
) {
  const conBody = Object.assign({}, body, {
    nonce: nonce,
    timestamp: timestamp
  });
  const sortBody = sortObject(conBody);
  const paramsArray = [];

  for (const key in sortBody) {
    const value = sortBody[key];
    // 云端签名规则：数组和对象类型的数据，不参与签名，有key值但value为空
    if (typeof value != 'object' && !Number.isNaN(value)) {
      paramsArray.push(key + '=' + value);
    } else {
      paramsArray.push(key + '=');
    }
  }
  const paramsStr = paramsArray.join('&');
  const signkey = LogKeys[Env.webviewEnv as keyof typeof LogKeys];
  const signkeyObj = Base64.stringify(sha256(`${signkey}${version}`.toString()));
  const strWordArray = CryptoJS.enc.Utf8.parse(paramsStr);
  const key = CryptoJS.enc.Base64.parse(signkeyObj);
  const hmacSha256 = hmacSHA256(strWordArray, key);
  const signature = CryptoJS.enc.Base64.stringify(hmacSha256);
  return signature;
}

const Request = (data: any = {}) => {
  return new Promise((resolve, reject) => {
    const newData = Object.assign({}, data);
    const config = {
      method: 'post',
      headers: getHeader(newData),
      url: `${BaseUrls[Env.webviewEnv as keyof typeof BaseUrls]}`,
      data: newData
    };
    Axios(config)
      .then(res => {
        if (res.data.code === 0) {
          resolve(res.data.data);
        } else {
          reject(res.data);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

class DebugLog {
  static dealData(data: any, type = 1) {
    const isObj = Object.prototype.toString.call(data) === '[object Object]';
    const baseData = {
      level: type,
      deviceBrand: `${store.state.env.brand}_${Env.clientType}`,
      deviceModel: `${store.state.env.model}_${Env.browser}`,
      deviceOsVersion: `${store.state.env.model}_${Env.version}`,
      deviceWebVersion: `${Env.appName}_${Env.versionNum}`
    };
    if (isObj) {
      return {
        ...baseData,
        items: [
          {
            msg: JSON.stringify(data)
          }
        ]
      };
    } else {
      return {
        ...baseData,
        items: [
          {
            msg: JSON.stringify([...data])
          }
        ]
      };
    }
  }
  static info(...args: any[]) {
    const newData = DebugLog.dealData(args, 1);
    Request(newData);
  }
  static error(...args: any[]) {
    const newData = DebugLog.dealData(args, 3);
    Request(newData);
  }
  static warn(...args: any[]) {
    const newData = DebugLog.dealData(args, 3);
    Request(newData);
  }
}

export default DebugLog;
